import { makeStyles } from "@mui/styles";

export const useRecurrenceCardStyles = makeStyles(() => ({
    hr: {
        borderLeft: "1px solid #DEDEDE",
        width: "1px",
        alignSelf: "stretch",
    },
}));
